import { useContext, useEffect, useState } from "react"
import { AppContext } from "../App"
import { getInlineLoader } from "../Helpers";
import HomeBanner1 from "../ones/HomeBanner1";
import News from "../main-views/News";
import ClientsBanner from "../ones/ClientsBanner";
import Gallery from "../main-views/Gallery";

import Footer from "../ones/Footer";
import HomeBanner2 from "../ones/HomeBanner2";
import ServicesBanner1 from "../ones/ServicesBanner1";
import HomeBanner3 from "../ones/HomeBanner3";
import Staff from "../main-views/Staff";
import TestimonialsBanner from "../ones/TestimonialsBanner";

export default function View(props) {

	const appContext = useContext(AppContext);

	/* Place states here */
	const [ ready, setReady ] = useState(false);

	async function init() {
		//run initializations here
		setReady(false);
		//..
		
		setReady(true);
	}

	useEffect(() => {
		init();
	}, [ ])

	if(ready) {
		return (
			<>
				<HomeBanner1/>
				<HomeBanner2/>
				<HomeBanner3/>
				<ServicesBanner1/>
				<ClientsBanner/>
				<Staff/>
				<News/>
				<Gallery/>
				<TestimonialsBanner/>
				<Footer/>
			</>
		)
	} else {
		return (
			<div 
				className="container mSupportLoading"
			>
				{getInlineLoader()}
			</div>
		);
	}

	
}